// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .App {
    text-align: center;
    margin-top: 75px;
  }
  .App-logo {
    height: 40vmin;
    pointer-events: none;
  }

  @media (prefers-reduced-motion: no-preference) {
    .App-logo {
      animation: App-logo-spin infinite 20s linear;
    }
  }

  .App-header {
    background-color: #282c34;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
  }

  .App-link {
    color: #61dafb;
  }

  @keyframes App-logo-spin {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
    
  }
  .MuiTextField-root .MuiOutlinedInput-root {
    padding: 0px 0px;
  }


  .swiper-button-next, .swiper-button-prev {
    z-index: 10 !important;
}

.react-multiple-carousel__arrow--right {
  /* right: -10px; */
margin-right:10px;
  z-index: 10 !important;
}
.react-multiple-carousel__arrow--left {
  /* right: -10px; */
  z-index: 10 !important;
}
/* .dropdown-item{
  border-bottom: solid 1px #e6dfdf;
} */
.navbar-expand-lg .navbar-nav .dropdown-menu {
  padding-bottom: 0px;
}
.project-description p {
  font-size: 16px;
  line-height: 1.6;
  color: #333;
}

.project-description ul {
  padding-left: 20px;
  list-style-type: disc;
}

.project-description li {
  margin-bottom: 8px;
}

.project-description h1, 
.project-description h2, 
.project-description h3 {
  font-size: 15px;
  color: black;
  font-weight: 600;
  margin-top: 10px;
}

.project-description strong {
  font-weight: bold;
  /* color: #ff5733; */
}

/* Handle new lines (\\n) by adding block display */
.project-description br {
  display: block;
  margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"EAAE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE;MACE,4CAA4C;IAC9C;EACF;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE;MACE,uBAAuB;IACzB;;IAEA;MACE,yBAAyB;IAC3B;;EAEF;EACA;IACE,gBAAgB;EAClB;;;EAGA;IACE,sBAAsB;AAC1B;;AAEA;EACE,kBAAkB;AACpB,iBAAiB;EACf,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;;GAEG;AACH;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,kDAAkD;AAClD;EACE,cAAc;EACd,mBAAmB;AACrB","sourcesContent":["  .App {\n    text-align: center;\n    margin-top: 75px;\n  }\n  .App-logo {\n    height: 40vmin;\n    pointer-events: none;\n  }\n\n  @media (prefers-reduced-motion: no-preference) {\n    .App-logo {\n      animation: App-logo-spin infinite 20s linear;\n    }\n  }\n\n  .App-header {\n    background-color: #282c34;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n  }\n\n  .App-link {\n    color: #61dafb;\n  }\n\n  @keyframes App-logo-spin {\n    from {\n      transform: rotate(0deg);\n    }\n\n    to {\n      transform: rotate(360deg);\n    }\n    \n  }\n  .MuiTextField-root .MuiOutlinedInput-root {\n    padding: 0px 0px;\n  }\n\n\n  .swiper-button-next, .swiper-button-prev {\n    z-index: 10 !important;\n}\n\n.react-multiple-carousel__arrow--right {\n  /* right: -10px; */\nmargin-right:10px;\n  z-index: 10 !important;\n}\n.react-multiple-carousel__arrow--left {\n  /* right: -10px; */\n  z-index: 10 !important;\n}\n/* .dropdown-item{\n  border-bottom: solid 1px #e6dfdf;\n} */\n.navbar-expand-lg .navbar-nav .dropdown-menu {\n  padding-bottom: 0px;\n}\n.project-description p {\n  font-size: 16px;\n  line-height: 1.6;\n  color: #333;\n}\n\n.project-description ul {\n  padding-left: 20px;\n  list-style-type: disc;\n}\n\n.project-description li {\n  margin-bottom: 8px;\n}\n\n.project-description h1, \n.project-description h2, \n.project-description h3 {\n  font-size: 15px;\n  color: black;\n  font-weight: 600;\n  margin-top: 10px;\n}\n\n.project-description strong {\n  font-weight: bold;\n  /* color: #ff5733; */\n}\n\n/* Handle new lines (\\n) by adding block display */\n.project-description br {\n  display: block;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
